import React from 'react';
import PropTypes from 'prop-types';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import defaultStyles from 'commonStyles/components/coupon/_coupon-error-box';
import styleOverrides from 'styles/components/coupon/_coupon-error-box';
import AlertIcon from 'common/icons/loyalty/alert';

const CouponErrorBox = ({
  title, description, style, className,
}) => {
  const styles = useStyleOverrides(defaultStyles, styleOverrides);
  let wrapperClassName = styles.wrapper;

  if (className) {
    wrapperClassName = `${wrapperClassName} ${className}`;
  }

  return (
    <div className={wrapperClassName} role="alert" style={style}>
      <AlertIcon className={styles.icon} />
      <div className={styles.textWrapper}>
        {title && <span className={styles.title}>{title}</span>}
        <span>{description}</span>
      </div>
    </div>
  );
};

CouponErrorBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CouponErrorBox;
